import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-navy-900 border-y border-silver/20" data-id="element-107" data-mp="4vrz7ul6w7pa">
      <div className="container mx-auto px-4 text-center" data-id="element-108" data-mp="9u38a33nue6g">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-navy-950/80 rounded-3xl p-8 md:p-12 shadow-2xl border border-silver/30" data-id="element-109" data-mp="9wpenzetenn3">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-navy-800 text-silver mb-6 border border-silver/30" data-id="element-110" data-mp="sldwgci04cun">
            <ShieldCheckIcon className="w-10 h-10" data-id="element-111" data-mp="12ja9j9ui1hve" />
          </div>

          <h2 className="text-3xl font-extrabold text-white mb-4" data-id="element-112" data-mp="12gxim76rjx67">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-lg text-silver mb-6" data-id="element-113" data-mp="25rnl1588kwvx">
            Abrís los tomos. Los usás. Si en 7 días no es lo que esperabas:
          </p>

          <div className="bg-navy-800/60 text-silver-light font-bold text-xl py-4 px-6 rounded-xl mb-6 border border-silver/25" data-id="element-114" data-mp="20r98b9vowyrk">
            Devolución del 100% sin formularios, sin drama.
          </div>

          <p className="text-sm text-silver-dark font-medium uppercase tracking-wider" data-id="element-115" data-mp="1rtqkjxqnw6bz">
            Tasa de devoluciones: menos del 1%.
          </p>
        </motion.div>
      </div>
    </section>;
}